import { useNavigate } from "react-router-dom";
import { HeaderSidebar } from "../../../components/Header/HeaderSidebar"
import { useEffect, useState } from "react";
import { getVisionForm } from "../../../services/autofillService";
import { Formik, Form, Field, FieldArray } from "formik";
import { Step } from "../../../components/Step/Step";
import { getClassName } from "../../../utils";
import { questions, videos } from "../../../content/vision";
import { UpButton } from "../../../components/Buttons/UpButton";
import { AddMore } from "../../../components/Buttons/AddMoreButton";
import { DownButton } from "../../../components/Buttons/DownButton";
import { TextareaAutosize } from "@mui/material";
import { useDispatch } from "react-redux";
import { setProgress } from "../../../store/progressSlice";
import { ProgressLine } from "../../../components/Progress/Line";
import { Buttons } from "../../../components/Stepper/StepperButtons";
import { Oval } from "react-loader-spinner";
import { submitVision } from "../../../services/answersService";
import { getVisionStatement } from "../../../services/statementsService";

export const Vision = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [isLoading, setIsLoading] = useState(0);
    const [initialValues, setInitialValues] = useState({
        companyPotential: [
            {
                companyPotential: ''
            }
        ],
        worldPotential: ''
    });

    const handleSubmit = values => {
        setIsLoading(true);
        submitVision(values).then(response => {
            setIsLoading(false);
            navigate("/flow/personality/introduction");
            // navigate("/flow/vision/statement")
        }).catch(err => {
            setIsLoading(false);
            console.error(err);
        })

        // getVisionStatement().then(response => {
        //     const data = response.data;
        //     navigate("/flow/personality/introduction");
        // }).catch(err => {
        //     console.error(err);
        // })
    }

    const handleUpClick = () => {
        setActiveStep(activeStep - 1);
        if (activeStep === 1) {
            dispatch(setProgress(47))
        }
    }

    const handleDownClick = () => {
        setActiveStep(activeStep + 1);
        if (activeStep === 0) {
            dispatch(setProgress(50));
        }
    }

    useEffect(() => {
        dispatch(setProgress(47))
        getVisionForm().then(response => {
            const data = response.data;
            if (data) {
                setInitialValues(data);
            }
        }).catch(err => {
            console.error(err);
        })
    }, []);
    return (
        <>
            <ProgressLine />
            <section className="h-dvh overflow-hidden flex flex-col items-center justify-center">
                <Formik
                    initialValues={initialValues}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched }) => (
                        <>
                            <Form className="w-full max-w-[35%] h-full relative flex flex-col items-start justify-center">
                                <section className="flex flex-col items-center justify-center w-full h-full">
                                    <Step className={getClassName(0, activeStep)} question={questions.companyPotential} url={videos.companyPotentialVideo.url}>
                                        <FieldArray name="companyPotential">
                                            {({ insert, remove, push }) => (
                                                <>
                                                    {values.companyPotential.length > 0 &&
                                                        values.companyPotential.map((companyPotential, index) => (
                                                            <Field
                                                                name={`companyPotential.${index}.companyPotential`}
                                                                placeholder="To be..."
                                                                className="has-border-bottom mt-3"
                                                                key={index}
                                                                as={TextareaAutosize}
                                                            />
                                                        ))
                                                    }
                                                    <AddMore onClick={() => push({ companyPotential: '' })} />
                                                </>
                                            )}
                                        </FieldArray>
                                    </Step>
                                    <Step className={getClassName(1, activeStep)} question={questions.worldPotential} url={videos.worldPotentialVideo.url}>
                                        <Field
                                            name="worldPotential"
                                            placeholder="When we've reached our full potential, the world will…"
                                            className="has-border-bottom mt-3"
                                            as={TextareaAutosize}
                                        />
                                    </Step>
                                </section>
                                <Buttons link="/flow/purpose/product">
                                <UpButton onClick={handleUpClick} disabled={activeStep === 0} />
                                    {(activeStep === 1) ? (
                                        <button type="submit" className="btn yellow-cta">
                                            {isLoading ? <Oval
                                                height={30}
                                                width={50}
                                                color="black"
                                                secondaryColor="black"
                                            /> : (
                                                <span>
                                                    Next
                                                </span>
                                            )}
                                        </button>
                                    ) : (
                                        <DownButton onClick={handleDownClick} disabled={activeStep === 1} />
                                    )}
                                </Buttons>
                            </Form>
                        </>
                    )}

                </Formik>
            </section>
            <HeaderSidebar activeEl="Vision" />
        </>
    )
}